// src/services/testimonialsService.js
import apiClient from './apiClient.js'

export const testimonialsService = {
    getTestimonials(params = {}) {
        return apiClient.get('/testimonials', { params })
    },

    createTestimonial(data) {
        return apiClient.post('/testimonials', data)
    },

    updateTestimonial(id, data) {
        return apiClient.put(`/testimonials/${id}`, data)
    },

    deleteTestimonial(id) {
        return apiClient.delete(`/testimonials/${id}`)
    },
}